/** Display label for company.companyName (repossession firm / agency). */
export const BANK_NBFC_NAME_LABEL = "Agency name";

/** SSDI create company — company name field label. */
export const AGENCY_NAME_LABEL = "Agency name";

/** SSDI create page — repossession firm / agency wording. */
export const REPOSSESSION_FIRM_AGENCY = "Repossession firm / agency";
export const CREATE_REPOSSESSION_FIRM_AGENCY = "Create Repossession Firm / Agency";

/** Repo admin — firm & admin settings page. */
export const AGENCY_PROFILE_TITLE = "Profile";
export const AGENCY_PROFILE_MENU_LABEL = "Profile";

/** Repo staff — personal details page. */
export const STAFF_PROFILE_TITLE = "Profile";
export const STAFF_PROFILE_MENU_LABEL = "Profile";
